import { createSlice } from '@reduxjs/toolkit'

const initialState = { unit:[]}

const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    addVideo(state, action) {
       return action.payload
    }
  },
})

export const { addVideo } = videoSlice.actions
export default videoSlice.reducer